module.exports = __webpack_public_path__ + "8723fc16d3649200d6179f391dd43f9f.ttf";